const DEFAULT_TIME_ZONE = process.env.REACT_APP_DISPLAY_TIMEZONE || 'Asia/Kolkata';
const DEFAULT_LOCALE = process.env.REACT_APP_DISPLAY_LOCALE || 'en-IN';

  /**
   * Format UTC datetime string with seconds (useful for audit logs)
   */
  export const formatDateWithSeconds = (value) => {
    if (value === undefined || value === null || value === '') return '';
  
    let d = null;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === 'number') {
      d = new Date(value > 1e12 ? value : value * 1000);
    } else {
      const input = String(value).trim();
      if (!input) return '';
      if (/^\d+$/.test(input)) {
        const num = Number(input);
        d = new Date(num > 1e12 ? num : num * 1000);
      } else {
        const hasTZ = /([+-]\d{2}:?\d{2}|Z)$/i.test(input);
        const normalized = hasTZ ? input : `${input}Z`;
        const parsed = new Date(normalized);
        d = isNaN(parsed.getTime()) ? null : parsed;
      }
    }
  
    if (!d || isNaN(d.getTime())) return '';
  
    return d.toLocaleString(DEFAULT_LOCALE, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: DEFAULT_TIME_ZONE,
    });
  };

  export const formatDateWithSecondsWithoutFormat = (dateString) => {
    if (!dateString) return '';
    
    const utcString = dateString ;
    
    return new Date(utcString).toLocaleString(DEFAULT_LOCALE, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: DEFAULT_TIME_ZONE,
    });
  };
  
  /**
   * Format UTC datetime for simple display (date only)
   */
  export const formatDateOnly = (dateString) => {
    if (!dateString) return '';
    
    const utcString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
    
    return new Date(utcString).toLocaleDateString(DEFAULT_LOCALE, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: DEFAULT_TIME_ZONE,
    });
  };

  export const formatDate = (value, showSeconds = false, date = true, hour24 = false, milliseconds= false) => {
  if (!value && value !== 0) return '-';

  let d = null;

  // Handle different input types
  if (typeof value === 'number') {
    // Assume epoch seconds if too small for milliseconds
    d = new Date(value > 1e12 ? value : value * 1000);
  } else if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      // Numeric string → treat as timestamp
      const num = Number(trimmed);
      d = new Date(num > 1e12 ? num : num * 1000);
    } else {
      // ISO or date string → ensure UTC if needed
      const utcString = trimmed.endsWith('Z') ? trimmed : trimmed + 'Z';
      d = new Date(utcString);
    }
  } else if (value instanceof Date) {
    d = value;
  }

  if (!d || isNaN(d.getTime())) return '-';

  // Format options
  const options = {};

  if (date) {
    // Include date part only when date=true
    options.year = 'numeric';
    options.month = 'short';
    options.day = 'numeric';
  }

  // Always include time
  options.hour = '2-digit';
  options.minute = '2-digit';

  if (showSeconds) options.second = '2-digit';

  if (hour24) options.hour12 = !hour24;

  if (milliseconds) options.fractionalSecondDigits = 3; // Show milliseconds

    return d.toLocaleString(DEFAULT_LOCALE, { ...options, timeZone: DEFAULT_TIME_ZONE });
};

